<script lang="ts">
	import { CircleHelp, Ellipsis, Handshake, Lock, Logs } from 'lucide-svelte';

	import { page } from '$app/state';
	import type { ComponentProps } from 'svelte';

	import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
	import * as Sidebar from '$lib/components/ui/sidebar';

	import UpdatedPill from '../updated-pill.svelte';

	let {
		hasChangelogUpdates
	}: {
		hasChangelogUpdates: boolean;
	} & ComponentProps<typeof Sidebar.Root> = $props();

	const items = [
		{
			title: 'FAQ',
			icon: CircleHelp,
			url: '/about/faq'
		},
		{
			title: 'Change Log',
			icon: Logs,
			url: '/about/changelog',
			highlighted: hasChangelogUpdates
		},
		{
			title: 'Privacy Policy',
			icon: Lock,
			url: '/about/privacy'
		},
		{
			title: 'Terms & Conditions',
			icon: Handshake,
			url: '/about/terms'
		}
	];
</script>

<Sidebar.Menu class="flex">
	<Sidebar.MenuItem>
		<Sidebar.MenuButton isActive={page.url.pathname.startsWith('/about/feedback')}>
			{#snippet child({ props })}
				<a href="/about/feedback" {...props}>
					<span>Feedback</span>
				</a>
			{/snippet}
		</Sidebar.MenuButton>

		<DropdownMenu.Root>
			<DropdownMenu.Trigger>
				{#snippet child({ props })}
					<Sidebar.MenuAction {...props}>
						<Ellipsis class="text-muted-foreground" />
						{#if hasChangelogUpdates}
							<UpdatedPill class="-mr-2 -mt-4" />
						{/if}
					</Sidebar.MenuAction>
				{/snippet}
			</DropdownMenu.Trigger>

			<DropdownMenu.Content side="right" align="start">
				{#each items as item (item)}
					<a href={item.url}>
						<DropdownMenu.Item>
							<item.icon />
							{item.title}
							{#if item.highlighted}
								<UpdatedPill />
							{/if}
						</DropdownMenu.Item>
					</a>
				{/each}
			</DropdownMenu.Content>
		</DropdownMenu.Root>
	</Sidebar.MenuItem>
</Sidebar.Menu>
